import * as dateFns from 'date-fns'

/** 项目统一的时间格式（含秒）—— 与 .claude/CLAUDE.md 约定一致 */
const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss'

/** 项目统一的日期格式（无时间）—— 纯日期字段用 */
const DATE_FORMAT = 'yyyy-MM-dd'

/**
 * 输入为 null / undefined / 空字符串 / 无效时间 → 返回 '--'
 * 与表格 null 占位符约定一致（见 .claude/CLAUDE.md）
 */
const isInvalidInput = (s: unknown): boolean => {
	if (s == null) return true
	if (typeof s === 'string' && s.trim() === '') return true
	return false
}

/**
 * 把后端返回的时间（ISO 字符串 / 时间戳 / Date）格式化成 yyyy-MM-dd HH:mm:ss
 *
 * @example
 *   fmtDateTime('2026-06-22T10:30:00') // '2026-06-22 10:30:00'
 *   fmtDateTime(null)                   // '--'
 *   fmtDateTime('invalid')              // '--'
 */
export function fmtDateTime(s?: string | number | Date | null): string {
	if (isInvalidInput(s)) return '--'
	const d = new Date(s as string | number | Date)
	if (Number.isNaN(d.getTime())) return '--'
	return dateFns.format(d, DATE_TIME_FORMAT)
}

/**
 * 把后端返回的时间格式化成 yyyy-MM-dd（纯日期，无时间）
 *
 * @example
 *   fmtDate('2026-06-22T10:30:00') // '2026-06-22'
 *   fmtDate(null)                   // '--'
 */
export function fmtDate(s?: string | number | Date | null): string {
	if (isInvalidInput(s)) return '--'
	const d = new Date(s as string | number | Date)
	if (Number.isNaN(d.getTime())) return '--'
	return dateFns.format(d, DATE_FORMAT)
}
